import React from "react";
import logo from "../assets/logo-mark.png";
import Styles from "../styles/Loader.module.css";

const Loader = ({ text = "Loading" }) => {
  return (
    <div className={Styles.loader_container} role="status" aria-live="polite">
      <img src={logo} alt="" className={Styles.logo} />
      <span className={Styles.loader_text}>
        {text}
        <span className={Styles.dots} aria-hidden="true">
          <span />
          <span />
          <span />
        </span>
      </span>
    </div>
  );
};

export default Loader;
